export enum TagGa4Enum {
    EVENT_SCREEN_VIEW = 'screen_view',
    EVENT_CLICK = 'click',
    PATH_CONHECA_PRODUTOS = '/cadastro-investidor/conheca-produtos',
    IMPLEMENTATION_TEAM = 's000846:rtc',
}